import { useTranslation } from 'react-i18next';
import {
  IFitoList,
  IFitoListSettings,
} from '~/Components/FitoList/FitoListUncontrolled/interfaces';
import { useNavigation, useHasAccess, AccessList } from '~/Hooks';
import { routeReplacer } from '~/Helpers/String.helper';
import { Route } from '~/Constants/Routes.constants';
import { IMerchant, MerchantStatus } from '~/Models/DTO/Merchant.models';
import { merchantStatusType } from './useOrgMerchantListDesktopTableDefinition';
import React from 'react';
import { MissingInfoButton } from './MissingInfoButton';

export const useMerchantList = () => {
  // hooks
  const { t } = useTranslation();
  const { navigate, getParams } = useNavigation();
  const { domain } = getParams();
  const { hasAccess } = useHasAccess();

  const keyOfId: keyof IMerchant = 'uuid';
  const settings: IFitoListSettings = {
    search: false,
    pagination: false,
  };

  const createListItem = (item: IMerchant, domain: string, navigate: (path: string) => void) => ({
    header: item.name,
    subheader: item.address,
    actions: [{ name: 'test', onClick: () => {} }],
    customElement: !item.status ? <MissingInfoButton /> : null,
    onClick: () => {
      navigate(
        routeReplacer(Route.ORGANISATION_MERCHANT_SETTING, { domain, merchantId: item.uuid }),
      );
    },
    status: item.status
      ? {
          label: t(`organisation.merchant.status.${MerchantStatus[item.status]}`),
          color: merchantStatusType[item.status],
        }
      : null,
  });

  const pageTitle = hasAccess(AccessList.CREATE_MERCHANT)
    ? {
        title: t('settings.merchant'),
        onAddButtonClick: () =>
          navigate(
            routeReplacer(Route.ORGANISATION_MERCHANT_SETTING, {
              domain: domain || '',
              merchantId: 'new',
            }),
          ),
        actionName: t('app.add'),
      }
    : t('settings.merchant');

  const setItemValues = (item: IMerchant): IFitoList =>
    createListItem(item, domain || '', navigate);

  return {
    title: pageTitle,
    keyOfId,
    settings,
    setItemValues,
    titleAsString: t('settings.merchant'),
  };
};
